var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { DisputeFeature } from '../../typings';
import { ModalType } from '../../redux/ui/typings';
import { openModal } from '../../redux/ui/ui.slice';
import { customerCareNumber } from '../../const/customerCareNumber';
export var initialState = {
    accountId: null,
    operationId: '',
    customerCareNumber: customerCareNumber,
    feature: DisputeFeature.Eligibility,
    parentSecureMessage: function () { return null; },
    returnToParent: function () { return null; },
    navigationHandler: function () { return null; },
    selectedDispute: null
};
var appConfigSlice = createSlice({
    name: 'appConfig',
    initialState: initialState,
    reducers: {
        updateAppConfig: function (state, action) {
            var payload = action.payload;
            return __assign(__assign({}, state), payload);
        },
        unsetAccountID: function (state) {
            return __assign(__assign({}, state), { accountId: null });
        }
    },
    extraReducers: function (builder) {
        builder.addMatcher(openModal.match, function (state, action) {
            /*
             * TODO:
             * * Figure out why we treat the Questionnaire modal different than
             *   the rest.
             * * `feature` and `modalType` are both used in similar ways, except
             *   that the former is passed as a prop by MMA and the later used
             *   internally for our modals. Figure out if it's necessary to have both.
             */
            if (action.payload === ModalType.Questionnaire) {
                state.feature = DisputeFeature.Questionnaire;
            }
        });
    }
});
export var updateAppConfig = (_a = appConfigSlice.actions, _a.updateAppConfig), unsetAccountID = _a.unsetAccountID;
export default appConfigSlice.reducer;
//# sourceMappingURL=appConfig.slice.js.map